import { isValidCNPJ } from "@/functions/helpers";

export default {
  computed: {
    validDocument() {
      const document = this.$user.user?.company?.document;
      return document && isValidCNPJ(document);
    }
  },
  methods: {
    validateCNPJ() {
      const document = this.$user.user?.company?.document;
      if (!document || !isValidCNPJ(document)) {
        this.$message.error(
          "Preencha o CNPJ de sua empresa nos seus dados pessoais para fazer a integração."
        );
        this.$emit("input", false);
      }
    }
  }
};
